import styled from 'styled-components';
import { PrimaryButton } from '@carvana/showroom-forms';

export const ComingSoonModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  align-items: center;
  padding: 2rem;
`;

export const ComingSoonModalHeader = styled.h1`
  //  there is no typeStyle header-l in theme
  margin: 12px 0px;
  text-align: center;
`;

export const ComingSoonModalBody = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  margin: 12px 0px 24px 0;
  color: ${(props) => props.theme.color.neutral.v500};
  padding: 4px 12px;
  whitespace: pre-wrap;
`;

export const ContinueButton = styled(PrimaryButton)`
  margin: 12px 0;
`;
